(function ($) {
  var initializeHeroBlock = function ($block) {
    // console.log("init slick hero", $block);
    $(".heroSliderNew").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      fade: true,
      arrows: false,
      cssEase: "linear",
      speed: 500,
      pauseOnHover: false,
      pauseOnFocus: false,
    });
    //   $load = true;
  };

  // Initialize each block on page load (front end).
  $(document).ready(function () {
    // console.log("Page loaded");
    initializeHeroBlock();
  });

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    // window.acf.addAction("render_block_preview", initializeHeroBlock);
  }
})(jQuery);
